module.exports = __webpack_public_path__ + "img/meilleur_choix.f500a402.png";